import React, { useState } from "react";
import { Table, Input, Button, Space, Tooltip, Slider } from "antd";
import filterData from "../utils/filterData";

export default function PokemonTable() {
    const [state, setState] = useState({
        league: "all",
        rank: "1",
        att: "0",
        def: "0",
        hp: "0",
        lv: "40",
    });

    const [data, setData] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const values = { ...state, [name]: value };
        const { rank, att, def, hp, lv } = values;
        let newData = [];
        if (values.league === "all") {
            newData = [
                ...filterData.getGreatLeague(rank, att, def, hp, lv),
                ...filterData.getUltraLeague(rank, att, def, hp, lv),
            ];
        } else if (values.league === "gl") {
            newData = [...filterData.getGreatLeague(rank, att, def, hp, lv)];
        } else if (values.league === "ul") {
            newData = [...filterData.getUltraLeague(rank, att, def, hp, lv)];
        }
        newData = newData.map((item, index) => {
            item.key = index;
            return item;
        });
        setData([...newData]);
        setState({ ...values });
    };

    const columns = [
        { title: "Rank", dataIndex: "rank", key: "rank" },
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "ATT", dataIndex: "att", key: "att" },
        { title: "DEF", dataIndex: "def", key: "def" },
        { title: "HP", dataIndex: "hp", key: "hp" },
        { title: "LVL", dataIndex: "lv", key: "lv" },
        { title: "CP", dataIndex: "cp", key: "cp" },
        { title: "% Perfect", dataIndex: "perfect", key: "perfect" },
    ];

    return (
        <div className="container pt-2">
            <div className="title mb-3">
                <img src={require("../assets/p1.png").default} alt="pokeball" />
                <h1 className="ms-3">Search Pokemon by IV</h1>
            </div>
            <div className="row">
                <div className="col-6">
                    <select
                        onChange={handleChange}
                        name="league"
                        className="form-control"
                        id="league"
                    >
                        <option value="all">All League</option>
                        <option value="gl">Great League</option>
                        <option value="ul">Ultra League</option>
                    </select>
                </div>
                <div className="col-6">
                    <select
                        onChange={handleChange}
                        name="rank"
                        className="form-control"
                        id="rank"
                    >
                        <option value="1">Rank 1</option>
                        <option value="5">Rank 5</option>
                    </select>
                </div>
                <div className="col-3 iv mt-3">
                    <label>ATT:</label>
                    <select
                        onChange={handleChange}
                        className="form-control"
                        name="att"
                        id="att"
                    >
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                    </select>
                </div>
                <div className="col-3 iv mt-3">
                    <label>DEF:</label>
                    <select
                        onChange={handleChange}
                        className="form-control"
                        name="def"
                        id="def"
                    >
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                    </select>
                </div>
                <div className="col-3 iv mt-3">
                    <label>HP:</label>
                    <select
                        onChange={handleChange}
                        className="form-control"
                        name="hp"
                        id="hp"
                    >
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                    </select>
                </div>
                <div className="col-3 iv mt-3">
                    <label>LVL CAP:</label>
                    <select
                        onChange={handleChange}
                        className="form-control"
                        name="lv"
                        id="lv"
                    >
                        <option value="40">40</option>
                        <option value="50">50</option>
                        <option value="51">51</option>
                    </select>
                </div>
            </div>
            <div className="table mt-3">
                <Table columns={columns} dataSource={data} />
            </div>
        </div>
    );
}
